import { useJwtToken } from "@website/hooks/auth-manager";
import { daysBetweenDates } from "@website/utils/date-format";
import { numberConvert } from "@website/utils/number-convert";
import snappProIcon from "@website/widget/header/assets/pro_badge.svg";

export const useSnappPro = () => {
  const { snapp_pro } = useJwtToken();
  const hasSnappPro = Boolean(snapp_pro);
  const rawRemainingDays = hasSnappPro
    ? daysBetweenDates(new Date(), snapp_pro?.expiration_date)
    : 0;
  const snappProRemainingDays = Math.max(0, rawRemainingDays);
  return {
    hasSnappPro: snappProRemainingDays > 0,
    snappProRemainingDays,
    snappProIcon: (snappProIcon as unknown as { src: string }).src,
    snappProTitle: "اسنپ پرو",
    snappProSubTitle: `${numberConvert(snappProRemainingDays, {
      locale: "fa"
    })} روز باقی‌مانده`
  };
};
